// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kiIiD6bH2gBZgMh6gXhV{display:flex;flex-direction:column;width:100%;height:100%}._D6y7zahFMt281Rew8qs>div:first-child{height:0}._D6y7zahFMt281Rew8qs>div:last-child{height:100%}.Wita5PYEw4uOT6lud9IP>div:first-child{flex:0 1 auto}.Wita5PYEw4uOT6lud9IP>div:last-child{flex:1 1 auto;overflow:hidden}.OcEqWhDYoH_Qbm47cheE{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.jRqEsioOVOrWPnTNRGut{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.aQXPCHJ_c5et0tOrKVCh{width:100%;height:100%;margin:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootStyle": "kiIiD6bH2gBZgMh6gXhV",
	"standardLayout": "_D6y7zahFMt281Rew8qs",
	"discoverLayout": "Wita5PYEw4uOT6lud9IP",
	"creative": "OcEqWhDYoH_Qbm47cheE",
	"creativeContain": "jRqEsioOVOrWPnTNRGut",
	"creativeContainer": "aQXPCHJ_c5et0tOrKVCh"
};
export default ___CSS_LOADER_EXPORT___;
